import React, { useState } from 'react';
import WeekRowView from './WeekRowView';

const GOAL = 3;
const RING_R = 18;
const RING_C = 2 * Math.PI * RING_R;

function HabitItem({ name = 'Joga', onClick = () => {} }) {
  const [doneCount, setDoneCount] = useState(2);

  const isComplete = doneCount >= GOAL;
  const dashOffset = RING_C * (1 - Math.min(doneCount / GOAL, 1));

  const handleItemClick = () => {
    onClick({ name, doneCount });
  };

  return (
    <div
      onClick={handleItemClick}
      className="bg-zinc-800 border border-zinc-700 rounded-2xl px-4 py-3.5 flex items-center gap-4 w-fit mx-auto cursor-pointer shadow-lg hover:bg-zinc-700/60 transition-colors duration-150 select-none"
    >
      {/* Progress Ring */}
      <div className="relative w-12 h-12 flex-shrink-0 flex items-center justify-center">
        <svg className="absolute inset-0 -rotate-90" viewBox="0 0 44 44">
          <circle cx="22" cy="22" r={RING_R} fill="none" stroke="#3f3f46" strokeWidth="2.5" />
          <circle
            cx="22" cy="22" r={RING_R}
            fill="none"
            stroke={isComplete ? '#22c55e' : '#f97316'}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray={RING_C}
            strokeDashoffset={dashOffset}
            style={{ transition: 'stroke-dashoffset 0.3s ease, stroke 0.3s ease' }}
          />
        </svg>
        <span className={`text-xs font-bold relative z-10 ${isComplete ? 'text-green-400' : 'text-gray-300'}`}>
          {isComplete ? '✓' : `${Math.round(doneCount / GOAL * 100)}%`}
        </span>
      </div>

      {/* Habit Name */}
      <div className="text-sm font-semibold text-gray-100 min-w-fit flex-shrink-0 tracking-wide">
        {name}
      </div>

      {/* Week Row */}
      <WeekRowView onDoneCountChange={setDoneCount} />
    </div>
  );
}

export default HabitItem;
